import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import injectStyles from 'react-jss'
import { Checkbox } from '@material-ui/core'
import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import AddIcon from '@material-ui/icons/Add'
import SubmitButton from '../../../../../Components/Form/SubmitButton/index'
import Button from '@material-ui/core/Button'
import { ModalConfirmation } from 'Components/Modal/ModalConfirmation'
import { SearchInput } from 'Components/Header/SearchInput'

import * as CONST from 'Reducers/Location/const'
import {
  archiveLocation,
  setLocationsByCityIdStatusFilter,
  getLocationTypes,
} from 'Reducers/Location/actions'
import { showReduxModal } from 'Reducers/UI/actions'

import { downloadStringAsFile, processCsvFile } from '../../../../../Utils/Misc'
import { prepareDataSetForImport, validateLocationsCsv } from '../utils'
import { LOCATION_SORT_COLUMN_ENUM } from '../../../../../shared/constants'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'
import getLocationWithPagination, {
  importLocationsGQL,
  exportLocationsGQL,
  getLocationByIdGQL,
} from '../gql'
import Pagination from 'Components/FilterAndPaginationComponent/Pagination'
import { isDefined } from '../../../../../shared/libraries/utils/object'
import { styles } from './styles'
import H2HLocationsTable from '../Components/H2HLocationTable/H2HLocationsTable'
import {
  ONLY_PLATFORM_LOCATION,
  ONLY_SELF_SERVE_LOCATION,
  timeOfDayMapToFilter,
  CREATED_BY_OPTIONS,
  BOOLEAN_OPTIONS,
  TIMES_OF_DAY_OPTIONS,
} from '../options'
import { ExtendedSelect } from 'Components/ExtendedSelect'
import { Select } from 'Components/Form/Select'
import H2HLocationModal from '../Modals/H2HLocationModal'
import H2HLocationImportModal from '../Modals/H2HLocationImport'

const convertStringToBoolean = value => {
  if (!value) return null
  if (value === 'true') {
    return true
  }
  return false
}

const convertTimesOfDay = value => {
  if (value.includes('All')) {
    return []
  } else {
    return value.map(item => timeOfDayMapToFilter[item])
  }
}

const checkIfNeedToFetchSelfServe = value => {
  if (value === ONLY_PLATFORM_LOCATION) {
    return false
  }

  if (value === ONLY_SELF_SERVE_LOCATION) {
    return true
  }

  return null
}

const resultsPerPage = 50
const formatLocations = (isLoaded, data) =>
  isLoaded && data && data.city
    ? data.city.locations.edges.map(el => el.node)
    : []

const LocationsContainer = props => {
  const [locationId, setLocationId] = useState(null)
  const [importLocationsFile, setImportLocationsFile] = useState(null)
  const [offsetRecordsStart, setOffsetRecordsStart] = useState(0)
  const [searchString, setSearchString] = useState('')
  const [orderByColumn, setOrderByColumn] = useState({})
  const [reverse, setReverse] = useState(false)
  const [status, setStatus] = useState(null)
  const [isSelfServe, setIsSelfServe] = useState(null)
  const [sheltered, setSheltered] = useState(null)
  const [isEvent, setIsEvent] = useState(null)
  const [requirePermit, setRequirePermit] = useState(null)
  const [timesOfDay, setTimesOfDay] = useState(['All'])
  const [filterNAValues, setFilterNAValues] = useState(true)
  const [conversionRate, setConversionRate] = useState()
  const [scanRate, setScanRate] = useState(null)
  const [distributionRate, setDistributionRate] = useState(null)
  const [footTraffic, setFootTraffic] = useState(null)
  const [modalArchiveShow, setModalArchiveShow] = useState(false)
  const [modalImportLocationShow, setModalImportLocationShow] = useState(false)
  const [
    isNeedToResetExtendedSelects,
    setIsNeedToResetExtendedSelects,
  ] = useState(false)
  const [h2hModalProps, setH2HModalProps] = useState({
    modalShow: false,
  })

  const [importValidationErrors, setImportValidationErrors] = useState([])
  const [isImporting, setIsImporting] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [openedFromParam, setOpenedFromParam] = useState(false)

  const { data, isLoaded, refetch } = useGraphQLFetch({
    skipFetchOnInit: true,
    fetchFn: getLocationWithPagination,
    fetchId: 'getLocationWithPagination',
  })

  const dispatch = useDispatch()

  const availableLocationTypes = props.locationTypeOptions
    ? props.locationTypeOptions
        .filter(
          option =>
            !['Event', 'Festival', 'Sports / Events'].includes(option.label),
        )
        .map(option => option.label)
    : []

  const onOffsetChange = offset => {
    if (offset < 0) offset = 0
    if (offset > totalCount) return

    setOffsetRecordsStart(offset)
  }

  const calculatedTypeIds = useMemo(
    () =>
      props.locationTypeOptions.length > 0
        ? props.locationTypeOptions.reduce((acc, location) => {
            if (location.value != 25) {
              acc.push(Number(location.value))
            }
            return acc
          }, [])
        : undefined,
    [props.locationTypeOptions],
  )

  const searchHandler = searchString => setSearchString(searchString)

  const handleModalShow = type =>
    setH2HModalProps({
      modalShow: true,
      type,
      location: null,
    })

  const handleModalEditShow = location =>
    setH2HModalProps({
      modalShow: true,
      type: 'edit',
      location,
    })

  const handleModalCancel = () =>
    setH2HModalProps({
      modalShow: false,
    })

  const handleModalSubmitSuccess = () => {
    setH2HModalProps({
      modalShow: false,
    })
    fetchLocations()
  }

  const handleModalArchiveShow = useCallback(locationId => {
    setModalArchiveShow(true)
    setLocationId(locationId)
  }, [])
  const handleModalImportLocationShow = () => setModalImportLocationShow(true)

  const handleModalArchiveCancel = () => {
    setModalArchiveShow(false)
    setLocationId(null)
  }

  const handleModalImportLocationsCancel = () => {
    setImportValidationErrors([])
    setImportLocationsFile(null)
    setModalImportLocationShow(false)
  }

  const handleModalArchiveConfirm = () => {
    const callbacks = {
      onSuccess: fetchLocations,
    }

    setModalArchiveShow(false)
    setLocationId(null)

    dispatch(archiveLocation(callbacks, locationId))
  }

  const handleModalImportLocationsConfirm = async () => {
    try {
      if (!importLocationsFile) {
        return
      }

      const csvData = await processCsvFile(importLocationsFile)

      if (csvData.errors && csvData.errors.length > 0) {
        return
      }

      const validationResult = validateLocationsCsv(
        csvData,
        availableLocationTypes,
      )
      setImportValidationErrors(validationResult.errors)
      if (!validationResult.isValid) {
        return
      }
      setIsImporting(true)

      const dataSet = prepareDataSetForImport(validationResult.locations)
      await importLocationsGQL(dataSet, props.cityId)
      setModalImportLocationShow(false)
      fetchLocations()
      setIsImporting(false)
      setImportLocationsFile(null)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error processing CSV file:', error)
      setIsImporting(false)
    }
  }

  const currentColumnSort = (column, orderByColumn) => {
    let reverse = orderByColumn.reverse
    if (column == orderByColumn.column) {
      reverse = !reverse
    } else {
      reverse = true
    }
    switch (column) {
      case 'name':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.NAME_DESC,
            reverse,
          }
        } else {
          return { column, sortBy: LOCATION_SORT_COLUMN_ENUM.NAME_ASC, reverse }
        }
      case 'type':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.TYPE_DESC,
            reverse,
          }
        } else {
          return { column, sortBy: LOCATION_SORT_COLUMN_ENUM.TYPE_ASC, reverse }
        }

      case 'deliveredFlyersNumber':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.DELIVERED_FLYERS_NUMBER_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.DELIVERED_FLYERS_NUMBER_ASC,
            reverse,
          }
        }
      /// DM only sortings(below)
      case 'label':
        setReverse(false)
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.LABEL_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.LABEL_ASC,
            reverse,
          }
        }
      case 'momentsMorning':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_MORNING_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_MORNING_ASC,
            reverse,
          }
        }
      case 'momentsLunch':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_LUNCH_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_LUNCH_ASC,
            reverse,
          }
        }
      case 'momentsAfternoon':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_AFTERNOON_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_AFTERNOON_ASC,
            reverse,
          }
        }
      /// DM only sortings(above)
      case 'conversionRate':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.CONVERSION_RATE_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.CONVERSION_RATE_ASC,
            reverse,
          }
        }
      case 'scanRate':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.SCAN_RATE_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.SCAN_RATE_ASC,
            reverse,
          }
        }
      case 'deliveredFlyer':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.DELIVERED_FLYERS_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.DELIVERED_FLYERS_ASC,
            reverse,
          }
        }
      case 'footTraffic':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.FOOT_TRAFFIC_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.FOOT_TRAFFIC_ASC,
            reverse,
          }
        }
      case 'isSheltered':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_SHELTERED_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_SHELTERED_ASC,
            reverse,
          }
        }
      case 'isEvent':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_EVENT_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_EVENT_ASC,
            reverse,
          }
        }
      case 'requirePermit':
        if (reverse) {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_REQUIRE_PERMIT_DESC,
            reverse,
          }
        } else {
          return {
            column,
            sortBy: LOCATION_SORT_COLUMN_ENUM.IS_REQUIRE_PERMIT_ASC,
            reverse,
          }
        }
    }
  }

  const changeSort = useCallback(
    (columnName, orderByColumn) => {
      const sortData = currentColumnSort(columnName, orderByColumn)
      setOrderByColumn(sortData)
      setReverse(sortData.reverse)
    },
    [reverse],
  )

  const fetchLocations = () => {
    if (orderByColumn) {
      refetch({
        cityId: props.cityId,
        typeIds: calculatedTypeIds,
        orderBy: orderByColumn.sortBy,
        status,
        name: searchString,
        offset: offsetRecordsStart,
        first: resultsPerPage,
        isSelfServe: checkIfNeedToFetchSelfServe(isSelfServe),
        isSheltered: convertStringToBoolean(sheltered),
        isEvent: convertStringToBoolean(isEvent),
        isNeedPermit: convertStringToBoolean(requirePermit),
        times: convertTimesOfDay(timesOfDay),
        onlyWithStatistics: filterNAValues,
        conversionRate,
        scanRate,
        distributionRate,
        footTraffic,
      })
    } else {
      refetch({
        cityId: props.cityId,
        typeIds: calculatedTypeIds,
        status,
        name: searchString,
        offset: offsetRecordsStart,
        first: resultsPerPage,
        isSelfServe: checkIfNeedToFetchSelfServe(isSelfServe),
        isSheltered: convertStringToBoolean(sheltered),
        isEvent: convertStringToBoolean(isEvent),
        isNeedPermit: convertStringToBoolean(requirePermit),
        times: convertTimesOfDay(timesOfDay),
        onlyWithStatistics: filterNAValues,
        conversionRate,
        scanRate,
        distributionRate,
        footTraffic,
      })
    }
    setIsNeedToResetExtendedSelects(false)
  }

  useEffect(() => {
    fetchLocations()
  }, [
    offsetRecordsStart,
    resultsPerPage,
    orderByColumn,
    status,
    searchString,
    isSelfServe,
    sheltered,
    isEvent,
    requirePermit,
    timesOfDay,
    props.locationTypeOptions.length,
    filterNAValues,
    conversionRate
      ? `${conversionRate.operator} ${conversionRate.value1} ${
          conversionRate.value2
        }`
      : null,
    scanRate
      ? `${scanRate.operator} ${scanRate.value1} ${scanRate.value2}`
      : null,
    distributionRate
      ? `${distributionRate.operator} ${distributionRate.value1} ${
          distributionRate.value2
        }`
      : null,
    footTraffic
      ? `${footTraffic.operator} ${footTraffic.value1} ${footTraffic.value2}`
      : null,
  ])

  let locations = useMemo(() => formatLocations(isLoaded, data), [
    data,
    props.cityId,
    offsetRecordsStart,
    resultsPerPage,
    searchString,
    isLoaded,
  ])

  let totalCount =
    isLoaded && data && data.city ? data.city.locations.totalCount : 0
  const statusFilter = useSelector(
    state => state.locations.locationsByCityIdStatusFilter,
  )
  const searchValue = useSelector(
    state => state.locations.locationsByCityIdSearchValue,
  )

  useEffect(() => {
    if (statusFilter.value !== CONST.LOCATION_STATUS[0].value) {
      dispatch(setLocationsByCityIdStatusFilter(CONST.LOCATION_STATUS[0]))
    }

    dispatch(getLocationTypes())
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const preselectedId = params.get('preselectedLocationId')
    if (!preselectedId || openedFromParam) return
    const numericId = Number(preselectedId)
    if (!Number.isFinite(numericId)) return
    ;(async () => {
      try {
        const response = await getLocationByIdGQL(props.cityId, numericId)
        const { data } = await response.json()
        const node =
          data &&
          data.city &&
          data.city.locations &&
          data.city.locations.edges &&
          data.city.locations.edges[0] &&
          data.city.locations.edges[0].node
        if (node && Number(node.id) === numericId) {
          handleModalEditShow(node)
          setOpenedFromParam(true)
          const next = new URL(window.location.href)
          next.searchParams.delete('preselectedLocationId')
          window.history.replaceState({}, '', next.toString())
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch location by id for modal:', e)
      }
    })()
  }, [openedFromParam])

  const onBatchImportLocationFileChange = files =>
    setImportLocationsFile(files[0])

  const handleClickExportData = () => {
    dispatch(
      showReduxModal({
        title: 'Export Locations',
        children:
          'Heads up! When you export, any advanced availability schedules (like specific hours or yearly seasonality) will be simplified. The exported file will only show general Morning, Lunch, and Afternoon availability. Do you want to continue?',
        confirmLabel: `CONTINUE`,
        cancelLabel: `CANCEL`,
        onConfirm: onExportData,
      }),
    )
  }

  const onExportData = async () => {
    setIsExporting(true)
    const response = await exportLocationsGQL(props.cityId)
    const {
      data: { exportLocations },
    } = await response.json()

    if (exportLocations.success) {
      downloadStringAsFile(
        exportLocations.csvContent,
        exportLocations.filename || `city_${props.cityName}_locations.csv`,
        'text/csv',
      )
    } else {
      dispatch(
        showReduxModal({
          title: 'Export failed',
          children: exportLocations.errorMessage || 'Unknown error occurred',
          confirmLabel: `OK`,
          hideCancel: true,
        }),
      )
    }

    setIsExporting(false)
  }

  const handleTimesOfDayChange = value => {
    let data = value

    if (value.includes('All') && value.length > 1) {
      data = value.filter(item => item !== 'All')
    } else if (value.length === 0) {
      data = ['All']
    } else if (value.length === 1 && value.includes('All')) {
      data = ['All']
    }

    setTimesOfDay(data)
    setOffsetRecordsStart(0)
  }

  const onClearFilters = () => {
    setSearchString('')
    setStatus(null)
    setIsSelfServe(null)
    setSheltered(null)
    setIsEvent(null)
    setRequirePermit(null)
    setTimesOfDay(['All'])
    setOffsetRecordsStart(0)
    setDistributionRate(null)
    setFootTraffic(null)
    setScanRate(null)
    setConversionRate(null)
    setIsNeedToResetExtendedSelects(true)
    setFilterNAValues(false)
    const url = new URL(window.location.href)
    url.search = ''
    window.history.replaceState({}, '', url)
  }

  return (
    <div>
      <LayoutDashboard>
        <div style={styles.filterContainer}>
          <div style={styles.filterHeader}>
            <div style={{ maxWidth: '300px' }}>
              <SearchInput
                className="search-input"
                placeholder="Search anything"
                searchHandler={searchHandler}
                value={searchValue}
              />
            </div>
            <div style={{ display: 'flex', gap: '15px' }}>
              <SubmitButton
                value="Import"
                onClick={handleModalImportLocationShow}
              />

              <SubmitButton
                value="Export"
                onClick={handleClickExportData}
                disabled={isExporting}
                formSubmitting={isExporting}
              />
              <SubmitButton
                className="add-button-link"
                onClick={() => handleModalShow('add')}
                startIcon={<AddIcon />}
                disabled={!isLoaded}
              />
            </div>
          </div>

          <FilterBox className="filter-box">
            <div
              style={{
                display: 'flex',
                gap: '15px',
                flexWrap: 'wrap',
                marginBottom: 16,
              }}
            >
              <FilterSelect
                className="select-status"
                hasPrimaryText={false}
                label="Status"
                onChange={(e, index, value) => {
                  setStatus(value)
                  setOffsetRecordsStart(0)
                }}
                options={CONST.LOCATION_STATUS}
                value={status}
                sorted={true}
                minWidth="120px"
              />
              <FilterSelect
                className="select-status"
                hasPrimaryText={false}
                label="Created by"
                onChange={(e, index, value) => {
                  setIsSelfServe(value)
                  setOffsetRecordsStart(0)
                }}
                options={CREATED_BY_OPTIONS}
                value={isSelfServe}
                minWidth="120px"
              />
              <div style={styles.multiselectContainer}>
                <div style={styles.selectLabel}>Time availability</div>
                <Select
                  options={TIMES_OF_DAY_OPTIONS}
                  name={timesOfDay}
                  value={timesOfDay}
                  multiple={true}
                  listSubheaders={TIMES_OF_DAY_OPTIONS.filter(
                    option => option.isListSubheader,
                  )}
                  onChange={(e, i, value) => handleTimesOfDayChange(value)}
                  minWidth="120px"
                  cypress_id={'filterSelect'}
                />
              </div>
              <FilterSelect
                className="select-status"
                hasPrimaryText={false}
                label="Sheltered"
                onChange={(e, index, value) => {
                  setSheltered(value)
                  setOffsetRecordsStart(0)
                }}
                options={BOOLEAN_OPTIONS}
                value={sheltered}
                minWidth="120px"
              />
              <FilterSelect
                className="select-status"
                hasPrimaryText={false}
                label="Event"
                onChange={(e, index, value) => {
                  setIsEvent(value)
                  setOffsetRecordsStart(0)
                }}
                options={BOOLEAN_OPTIONS}
                value={isEvent}
                minWidth="120px"
              />
              <FilterSelect
                className="select-status"
                hasPrimaryText={false}
                label="Needs Permit"
                onChange={(e, index, value) => {
                  setRequirePermit(value)
                  setOffsetRecordsStart(0)
                }}
                options={BOOLEAN_OPTIONS}
                value={requirePermit}
                minWidth="120px"
              />
            </div>
            <div
              style={{
                display: 'flex',
                gap: '15px',
                flexWrap: 'wrap',
                marginBottom: '15px',
                width: '100%',
              }}
            >
              <ExtendedSelect
                label="Distribution rate"
                onUpdate={distributionRate => {
                  setDistributionRate(distributionRate)
                }}
                toInitValue={isNeedToResetExtendedSelects}
              />
              <ExtendedSelect
                label="Foot traffic"
                onUpdate={footTraffic => {
                  setFootTraffic(footTraffic)
                }}
                toInitValue={isNeedToResetExtendedSelects}
              />
              <ExtendedSelect
                label="Scan rate"
                onUpdate={scanRate => {
                  setScanRate(scanRate)
                }}
                toInitValue={isNeedToResetExtendedSelects}
              />
              <ExtendedSelect
                label="Conversion rate"
                onUpdate={conversionRate => {
                  setConversionRate(conversionRate)
                }}
                toInitValue={isNeedToResetExtendedSelects}
              />

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  checked={filterNAValues}
                  onChange={() => {
                    setFilterNAValues(!filterNAValues)
                  }}
                  cypress_id={'filterNAValues'}
                />
                <div
                  style={{
                    color: '#7F8FA4',
                    fontWeight: '600',
                    width: 'auto',
                  }}
                >
                  Hide N/A
                </div>
              </div>

              <Button
                variant="contained"
                onClick={onClearFilters}
                style={styles.clearFiltersButton}
              >
                Clear Filters
              </Button>
            </div>
          </FilterBox>
        </div>
      </LayoutDashboard>
      <div className={props.classes.tableWrapper}>
        <H2HLocationsTable
          cityId={props.cityId}
          locations={locations}
          changeSort={changeSort}
          handleModalArchiveShow={handleModalArchiveShow}
          handleModalEditShow={handleModalEditShow}
          orderByColumn={orderByColumn}
          orderByDirection={reverse}
        />
      </div>
      <Pagination
        total={isDefined(totalCount) ? totalCount : locations.length}
        offset={isDefined(offsetRecordsStart) ? offsetRecordsStart : 0}
        resultsPerPage={
          isDefined(resultsPerPage) ? resultsPerPage : locations.length
        }
        onOffsetChange={onOffsetChange}
      />
      {h2hModalProps.modalShow && (
        <H2HLocationModal
          handleCancel={handleModalCancel}
          handleSuccess={handleModalSubmitSuccess}
          locationTypeOptions={props.locationTypeOptions}
          locationId={locationId}
          city={data ? data.city : {}}
          {...h2hModalProps}
        />
      )}
      <ModalConfirmation
        handleCancel={handleModalArchiveCancel}
        handleConfirm={handleModalArchiveConfirm}
        modalShow={modalArchiveShow}
        text="Are you sure you want to archive this location?"
      />
      <H2HLocationImportModal
        onChange={onBatchImportLocationFileChange}
        validationErrors={importValidationErrors}
        handleCancel={handleModalImportLocationsCancel}
        handleConfirm={handleModalImportLocationsConfirm}
        modalShow={modalImportLocationShow}
        isImporting={isImporting}
      />
    </div>
  )
}
export default injectStyles(styles)(LocationsContainer)
